<div class="modal-header">
    <h4 class="modal-title">
        <i data-feather="plus"></i> {{data.dialogTitle}}
    </h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <ul ngbNav #nav="ngbNav" class="nav-tabs">
        <li ngbNavItem>
            <a ngbNavLink>İşlem</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-xl-4 col-md-12 col-sm-12">
                        <div class="col-12">
                            <div class="card shadow-none bg-transparent border-success">
                                <div class="card-header">
                                    <h4 class="card-title">Firma Bilgileri</h4>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-xl-4 col-md-6 col-sm-12"><strong>Firma Adı:</strong></div>
                                        <div class="col-xl-8 col-md-6 col-sm-12">{{
                                            calibrationDevice.company?.companyName }}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-4 col-md-6 col-sm-12"><strong>Teklif No:</strong></div>
                                        <div class="col-xl-8 col-md-6 col-sm-12">{{ calibrationDevice?.no }}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-4 col-md-6 col-sm-12"><strong>Adres:</strong></div>
                                        <div class="col-xl--8 col-md-6 col-sm-12">{{ calibrationDevice.company?.address
                                            }}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-4 col-md-6 col-sm-12"><strong>Telefon:</strong></div>
                                        <div class="col-xl-8 col-md-6 col-sm-12">{{
                                            calibrationDevice.company?.phoneNumber}}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-4 col-md-6 col-sm-12"><strong>Vergi No:</strong></div>
                                        <div class="col-xl-8 col-md-6 col-sm-12">{{ calibrationDevice.company?.taxNumber
                                            }}
                                            / {{calibrationDevice.company?.taxAdministration }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-12 col-md-12 col-sm-12">
                            <div class="card shadow-none bg-transparent border-info">
                                <div class="card-header">
                                    <h4 class="card-title">Cihaz Bilgileri</h4>
                                </div>
                                <div class="card-body">
                                    <p><strong>Cihaz Adı:</strong> {{calibrationDevice.deviceName}}</p>
                                    <div class="row">
                                        <div class="col-xl-6 col-md-6 col-sm-12">
                                            <div class="d-flex justify-content-between">
                                                <strong>Seri No:</strong>
                                                <span>{{ calibrationDevice.seriNo }}</span>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <strong>Tür:</strong>
                                                <span>{{ calibrationDevice.typeName }}</span>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <strong>Yer:</strong>
                                                <span>{{ calibrationDevice.place }}</span>
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-md-6 col-sm-12">
                                            <div class="d-flex justify-content-between">
                                                <strong>Marka:</strong>
                                                <span>{{ calibrationDevice.brandName }} - {{ calibrationDevice.modelName
                                                    }}</span>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <strong>Envanter No:</strong>
                                                <span>{{ calibrationDevice.inventoryNumber }}</span>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <strong>Çözünürlük:</strong>
                                                <span>{{ calibrationDevice.resolution }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-12 col-md-12 col-sm-12">

                            <div class="card shadow-none bg-transparent border-warning">
                                <div class="card-body">
                                    <label>Açıklamalar</label>
                                    <div class="input-group form-password-toggle mb-2">
                                        <input type="text" class="form-control" id="procedures"
                                            [value]="procedures[0]?.name" readonly="true" />
                                        <div class="input-group-append" (click)="basicPwdShow">
                                            <span class="input-group-text cursor-pointer" [ngbPopover]="popContent"
                                                popoverTitle="Detay" triggers="click:blur" container="body">
                                                <i class="feather" data-feather="eye"></i>
                                            </span>

                                            <!-- Popover İçeriği (ng-template) -->
                                            <ng-template #popContent>
                                                <div [innerHTML]="procedures[0].description"></div>
                                            </ng-template>
                                        </div>
                                    </div>

                                    <div class="input-group form-password-toggle mb-2">
                                        <input type="text" class="form-control" id="prodcures2"
                                            [value]="procedures[1]?.name" readonly="true" />
                                        <div class="input-group-append" (click)="basicPwdShow">
                                            <span class="input-group-text cursor-pointer" [ngbPopover]="popContent1"
                                                popoverTitle="Detay" triggers="click:blur" container="body">
                                                <i class="feather" data-feather="eye"></i>
                                            </span>

                                            <!-- Popover İçeriği (ng-template) -->
                                            <ng-template #popContent1>
                                                <div [innerHTML]="procedures[1].description"></div>
                                            </ng-template>
                                        </div>
                                    </div>

                                    <div class="input-group form-password-toggle mb-2">
                                        <input type="text" class="form-control" id="procedures3"
                                            [value]="procedures[2]?.name" readonly="true" />
                                        <div class="input-group-append" (click)="basicPwdShow">
                                            <span class="input-group-text cursor-pointer" [ngbPopover]="popContent2"
                                                popoverTitle="Detay" triggers="click:blur" container="body">
                                                <i class="feather" data-feather="eye"></i>
                                            </span>

                                            <!-- Popover İçeriği (ng-template) -->
                                            <ng-template #popContent2>
                                                <div [innerHTML]="procedures[2].description"></div>
                                            </ng-template>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>

                    <div class="col-xl-8 col-md-12 col-sm-12">
                        <div class="col-xl-12 col-md-12 col-sm-12 mb-1">
                            <div class="card shadow-none bg-transparent border-warning">
                                <div class="p-50">

                                    <div class="row">
                                        <div class="col-xl-2 col-md-6 col-sm-12"><strong>Sert Bas. Firma:</strong></div>
                                        <div class="col-xl-4 col-md-6 col-sm-12">
                                            <input type="text" class="form-control" id="basicInput" readonly="true"
                                                placeholder="Enter email"
                                                [(ngModel)]="calibrationDevice.certficateCompany" />
                                        </div>

                                        <div class="col-xl-2 col-md-6 col-sm-12"><strong>Ortam Şartı</strong></div>
                                        <div class="col-xl-4 col-md-6 col-sm-12">
                                            <ng-select [items]="environmentalContent"
                                                [(ngModel)]="enviromentalContentId" placeholder="Çevre şartı seç"
                                                bindValue="id" bindLabel="typeName">

                                                <!-- <ng-template ng-header-tmp>
                                                    <button
                                                        class="add-new-customer btn btn-flat-success cursor-pointer rounded-0 text-left p-50 w-100"
                                                        (click)="showCreateDeviceDialog(); select.blur(); select.close()">
                                                        <i data-feather="plus"></i>
                                                        <span class="align-middle ml-25">Yeni Cihaz Ekle</span>
                                                    </button>
                                                </ng-template> -->
                                                <ng-template ng-option-tmp let-item="item" let-index="index"
                                                    let-search="searchTerm">
                                                    <h6 class="mb-1">{{ item.deviceName }}</h6>
                                                    <div class="card-subtitle mb-2">
                                                        <p *ngFor="let environmental of item.enviromentalContent">
                                                            {{ environmental.name }}, {{ environmental.start }}, {{
                                                            environmental.end }}
                                                        </p>
                                                        {{ item.typeName }}
                                                    </div>
                                                </ng-template>

                                            </ng-select>
                                        </div>
                                    </div>

                                    <!-- İkinci satır -->
                                    <div class="row mt-1">
                                        <div class="col-xl-2 col-md-6 col-sm-12"><strong>Kal. Methodu</strong></div>
                                        <div class="col-xl-4 col-md-6 col-sm-12">
                                            <ng-select [items]="kindProcedures" [(ngModel)]="selectProcedureId"
                                                placeholder="Kalibrasyon methodu seç" bindValue="id" bindLabel="name">
                                            </ng-select>
                                        </div>

                                        <div class="col-xl-2 col-md-6 col-sm-12"><strong>Kal. Tarihi</strong></div>
                                        <div class="col-xl-4 col-md-6 col-sm-12">
                                            <ng2-flatpickr [config]="dateTimeStartOptions"
                                                [(ngModel)]="date"></ng2-flatpickr>
                                        </div>
                                    </div>

                                    <!-- Üçüncü satır -->
                                    <div class="row mt-1">
                                        <div class="col-xl-2 col-md-6 col-sm-12"><strong>Kal. Yapan</strong></div>
                                        <div class="col-xl-4 col-md-6 col-sm-12">
                                            <ng-select [items]="persons" [(ngModel)]="selectedPersonId"
                                                placeholder="Kalibrasyon Yapanı Seç" bindLabel="fullName"
                                                bindValue="id">
                                            </ng-select>
                                        </div>

                                        <div class="col-xl-2 col-md-6 col-sm-12"><strong>Akra. Kuruluşu</strong></div>
                                        <div class="col-xl-4 col-md-6 col-sm-12">
                                            <ng-select [items]="akradetionOrganization"
                                                [(ngModel)]="selectedAcradtionOrganizationId"
                                                placeholder="Akradite Kurumunu Seç" bindLabel="name" bindValue="id">
                                            </ng-select>
                                        </div>
                                    </div>

                                    <div class="row mt-1">
                                        <div class="col-xl-2 col-md-6 col-sm-12"><strong>Kal. Yeri</strong></div>
                                        <div class="col-xl-4 col-md-6 col-sm-12">
                                            <div class="custom-control custom-radio">
                                                <!-- <input type="checkbox" class="custom-control-input" id="customCheck1"
                                                    [(ngModel)]="isPlace" />
                                                <label class="custom-control-label" for="customCheck1"></label> -->

                                                <input type="radio" id="customRadio1" name="customRadio"
                                                    class="custom-control-input" [checked]="isPlace" (change)="isPlace = true" />
                                                <label class="custom-control-label" for="customRadio1">Yerinde</label>
                                            </div>
                                            <div class="custom-control custom-radio">
                                                <input type="radio" id="customRadio2" name="customRadio"
                                                    class="custom-control-input" [checked]="!isPlace" (change)="isPlace = false" />
                                                <label class="custom-control-label"
                                                    for="customRadio2">Laboratuvarda</label>
                                            </div>
                                        </div>

                                        <div class="col-xl-2 col-md-6 col-sm-12" *ngIf="!isPlace">
                                            Kabul Tarihi
                                        </div>
                                        <div class="col-xl-4 col-md-6 col-sm-12" *ngIf="!isPlace">
                                            <ng2-flatpickr [config]="dateTimeStartOptions"
                                                [(ngModel)]="date2"></ng2-flatpickr>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-12 col-md-12 col-sm-12">
                            <div class="card shadow-none bg-transparent border-warning">
                                <div class="form-group col-xl-6 col-md-8 col-sm-12">
                                    <label>Referans Cihazları Seç</label>
                                    <ng-select [items]="refereceDevices" (change)="onDeviceSelect($event)"
                                        [(ngModel)]="selectedDevice" placeholder="Referans Cihaz Seç" bindLabel="seriNo"
                                        bindValue="id">
                                        <ng-template ng-option-tmp let-item="item" let-index="index"
                                            let-search="searchTerm">
                                            <h6 class="mb-1">{{item.deviceName}}</h6>
                                            <p class="card-subtitle mb-2 text-muted">
                                                {{ item.brandName }} / {{item.modelName}} - {{item.seriNo}} -
                                                {{item.typeName}}
                                            </p>
                                        </ng-template>
                                    </ng-select>
                                </div>
                                <div class="table-responsive mt-1">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Kod</th>
                                                <th>Marka/Model</th>
                                                <th>Serial No</th>
                                                <th>Tür</th>
                                                <th>#</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let device of selectedDevices">
                                                <td>{{ device.code }}</td>
                                                <td>{{ device.brandName }} / {{ device.modelName }}</td>
                                                <td>{{ device.seriNo }}</td>
                                                <td>{{ device.typeName }}</td>
                                                <td>

                                                    <button type="button" class="btn btn-icon btn-flat-danger"
                                                        rippleEffect (click)="removeDevice(device)">
                                                        <span [data-feather]="'trash'"></span></button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end">
                            <button type="button" class="btn btn-success" [disabled]="isSaveDisabled()"
                                (click)="saveData()">Kaydet</button>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <!-- <li ngbNavItem>
            <a ngbNavLink>Referans Cihazlar</a>
            <ng-template ngbNavContent>

            </ng-template>
        </li> -->
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>

</div>